import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './paginator.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PaginatorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,

    FormsModule,
  ],
  exports: [
    PaginatorComponent
  ],
})
export class PaginatorModule { }
